export class ClassificaGescorDTO {
  denominazione: string;
  livello: string;
  abilitaInvioComunicazioniDipendenti: boolean;
}
